import FormikInput from 'components/formikFields/input'
import Header from 'components/headers/bulletins'
import { Form, Formik } from 'formik'
import { Schema } from './utils'
import Uploader from 'components/uploader'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { toggleDetail } from 'store/redux/moneyPoolBox'
import { useNavigate } from 'react-router-dom'
import { RootState } from 'store/redux'
import { toggleSupportModal } from 'store/redux/sidebar'
import SupportModal from 'components/modals/supportModal'
import { toggleImage } from 'store/redux/image'
import posthog from 'posthog-js'
import FundGoalPicker, {
    FUND_GOAL_QUESTION,
    FUND_GOAL_REQUIRED,
    FundGoal,
} from 'components/fundGoal'

export default function DetailAddMoneyPool() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const imageStore = useSelector((state: RootState) => state.imageReducer)
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )
    const [imageId, setImageId] = useState<number | undefined>()
    const [images, setImages] = useState<IUploadImage | undefined>(
        imageStore.image ? { file: imageStore.image } : undefined
    )
    const [goal, setGoal] = useState<FundGoal | ''>(store?.goal ?? '')
    const [goalDescription, setGoalDescription] = useState(
        store?.goal_description ?? ''
    )
    const [goalError, setGoalError] = useState<string | undefined>()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        posthog.capture('fund_create_started', {
            is_transfer: !!store?.isTransfer,
        })
    }, [])
    return (
        <>
            <Formik
                initialValues={{ name: store?.name ? store?.name : '' }}
                validationSchema={Schema}
                onSubmit={async (values) => {
                    if (goal === '') {
                        setGoalError(FUND_GOAL_REQUIRED)
                        toast.error(FUND_GOAL_REQUIRED)
                    } else if (!images) {
                        toast.error('تصویر صندوق اجباری می باشد')
                    } else {
                        dispatch(toggleImage({ image: images.file }))
                        dispatch(
                            toggleDetail({
                                name: values.name,
                                image_id: imageId,
                                goal,
                                goal_description: goalDescription.trim(),
                            })
                        )
                        posthog.capture('fund_create_step_completed', {
                            step_name: 'detail',
                            step_index: 1,
                            has_custom_image: !!images,
                            goal,
                            has_goal_description: goalDescription.trim() !== '',
                            is_transfer: !!store?.isTransfer,
                        })
                        navigate('/add-box/memberShip')
                    }
                }}
            >
                {({ submitForm, values, handleChange, errors, touched }) => (
                    <Form>
                        {/* min-h, not h: the goal card makes this page taller
                            than a phone screen, and a fixed height would let
                            the content run past the painted background. */}
                        <div className=" min-h-screen flex flex-col bg-main-bg">
                            <div className=" grow-0">
                                <Header title="مشخصات صندوق" />
                            </div>
                            <div className="grow">
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        نام صندوق
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            {' '}
                                            نام صندوق
                                            <span className=" text-red-1 mx-2">
                                                (اجباری)
                                            </span>
                                        </p>
                                        <FormikInput
                                            type="text"
                                            label=""
                                            name="name"
                                            placeholder="نام صندوق"
                                            className="text-sm font-normal"
                                            isGray
                                        />
                                        <div className=" text-left text-sm mt-1">
                                            {values.name.length}/25
                                        </div>
                                    </div>
                                </div>
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        هدف صندوق
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            {FUND_GOAL_QUESTION}
                                            <span className=" text-red-1 mx-2">
                                                (اجباری)
                                            </span>
                                        </p>
                                        <FundGoalPicker
                                            goal={goal}
                                            description={goalDescription}
                                            onGoalChange={(value) => {
                                                setGoal(value)
                                                setGoalError(undefined)
                                            }}
                                            onDescriptionChange={
                                                setGoalDescription
                                            }
                                            boxKind="moneypool"
                                            error={goalError}
                                        />
                                    </div>
                                </div>
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        تصویر صندوق
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            {' '}
                                            تصویر صندوق
                                            <span className=" text-red-1 mx-2">
                                                (اجباری)
                                            </span>
                                        </p>
                                        <Uploader
                                            images={images}
                                            setImages={setImages}
                                            setImageId={setImageId}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className=" grow-0">
                                <div className=" text-center my-4">
                                    <p>نیاز به راهنمایی دارید؟</p>
                                    <p
                                        className=" text-[#808080] underline"
                                        onClick={() =>
                                            dispatch(
                                                toggleSupportModal({
                                                    isOpenSupportModal: true,
                                                    source: 'fund_detail',
                                                })
                                            )
                                        }
                                    >
                                        با مشاور همیان تماس بگیرید
                                    </p>
                                </div>
                                <div className=" bg-white py-4 px-4">
                                    <button className=" w-full bg-green-1 rounded-2xl text-white py-3">
                                        ادامه
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
